import React, { useState } from 'react'
import { Terms } from '../AffTruthInLending/Terms'
import { Checkbox, Text, useModal } from '@afterpaytouch/core'
import styles from './style.module.css'
import { useCheckoutSizes } from '../../utils/responsive'
import { useTranslation } from '../../utils/convergence'
import { TruthInLendingModal } from '../TruthInLending/TruthInLendingModal'
import { PayMonthlyTILAModalKey } from '../../model/modalKey'

interface TermsWithCheckboxProps {
  onCheckboxChange?: (event: React.ChangeEvent<HTMLInputElement>) => void
  showErrorMessage: boolean
}

export const TermsWithCheckbox: React.FC<TermsWithCheckboxProps> = ({ onCheckboxChange, showErrorMessage }) => {
  const { t } = useTranslation()
  const { showModal } = useModal(PayMonthlyTILAModalKey)
  const [tilDisclosure, setTilDisclosure] = useState<boolean>(false)
  const { smallTextSize } = useCheckoutSizes()
  const [documentId, setDocumentId] = useState<string>('')
  const setDocumentIdToShow = (documentId: string, isTilDisclosure: boolean = false): void => {
    showModal()
    setTilDisclosure(isTilDisclosure)
    setDocumentId(documentId)
  }

  return (
    <div className={styles.wrapper}>
      <Checkbox
        error={showErrorMessage}
        label={
          <>
            <Terms setDocumentIdToShow={setDocumentIdToShow} />{' '}
            {showErrorMessage && (
              <div className={styles.checkboxErrorMessageContainer}>
                <Text color='Fire' size={smallTextSize}>
                  {t('financeFee:summary.acceptToContinue')}
                </Text>
              </div>
            )}
          </>
        }
        onChange={onCheckboxChange}
      />

      <TruthInLendingModal documentId={documentId} isTilDisclosure={tilDisclosure} />
    </div>
  )
}
